export default __webpack_public_path__ + "static/media/linear-operations.61b3f31a.jpg";